import { Sun, Moon, ArrowRight } from "lucide-react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { fr } from "../content/fr";

export default function Header() {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#" + id);
    }
  };

  return (
    <header className="site-header" data-testid="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="logo" data-testid="logo">
          <span className="logo__mark" aria-hidden="true"></span>
          {fr.brand.name}
        </Link>
        <nav className="nav-links" aria-label="Navigation principale">
          <a href="/#methode" onClick={goSection("methode")} data-testid="nav-methode">{fr.nav.methode}</a>
          <a href="/#moteur" onClick={goSection("moteur")} data-testid="nav-moteur">{fr.nav.moteur}</a>
          <a href="/#offre" onClick={goSection("offre")} data-testid="nav-offre">{fr.nav.offre}</a>
          <a href="/#angles" onClick={goSection("angles")} data-testid="nav-angles">{fr.nav.angles}</a>
          <a href="/#faq" onClick={goSection("faq")} data-testid="nav-faq">{fr.nav.faq}</a>
        </nav>
        <div className="header-actions">
          <button className="icon-btn" onClick={toggle} data-testid="theme-toggle-button"
            aria-label={theme === "dark" ? fr.theme.toLight : fr.theme.toDark}>
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <Link to="/pilote" className="btn btn--primary" data-testid="header-cta">
            {fr.nav.cta} <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </header>
  );
}
